module.exports = __webpack_public_path__ + "static/media/beef-guarantee.c2e5ecc9.jpg";